import { render, staticRenderFns } from "./Arbeitsplatzliste.vue?vue&type=template&id=4bfa2979"
import script from "./Arbeitsplatzliste.vue?vue&type=script&lang=js"
export * from "./Arbeitsplatzliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports